import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../../api/client';

export default function PromosForm({ editMode = false }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    media_file_id: '',
    trigger_time: '',
    trigger_day: '',
    frequency_minutes: '',
    frequency_songs: '',
    priority: 0,
    start_date: '',
    end_date: '',
    is_active: true,
  });

  useEffect(() => {
    if (editMode && id) loadPromo();
  }, [id, editMode]);

  async function loadPromo() {
    try {
      const res = await api.get(`/api/promos/${id}`);
      setFormData(res.data);
    } catch (err) {
      console.error('Failed to load promo', err);
    }
  }

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === 'checkbox' ? checked : value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editMode) {
        await api.put(`/api/promos/${id}`, formData);
      } else {
        await api.post('/api/promos', formData);
      }
      navigate('/promos');
    } catch (err) {
      console.error('Failed to save promo', err);
    }
  };

  return (
    <div className="p-6">
      <h1 className="mb-6 text-2xl font-bold text-dark-100">
        {editMode ? 'Edit Promo' : 'Add New Promo'}
      </h1>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-dark-300">Name</label>
          <input type="text" name="name" value={formData.name} onChange={handleChange} className="input" required />
        </div>
        <div>
          <label className="block text-sm font-medium text-dark-300">Media File ID</label>
          <input type="text" name="media_file_id" value={formData.media_file_id} onChange={handleChange} className="input" required />
        </div>
        <div>
          <label className="block text-sm font-medium text-dark-300">Trigger Time</label>
          <input type="time" name="trigger_time" value={formData.trigger_time} onChange={handleChange} className="input" />
        </div>
        <div>
          <label className="block text-sm font-medium text-dark-300">Trigger Day</label>
          <select name="trigger_day" value={formData.trigger_day} onChange={handleChange} className="input">
            <option value="">Any day</option>
            <option value="monday">Monday</option>
            <option value="tuesday">Tuesday</option>
            <option value="wednesday">Wednesday</option>
            <option value="thursday">Thursday</option>
            <option value="friday">Friday</option>
            <option value="saturday">Saturday</option>
            <option value="sunday">Sunday</option>
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-dark-300">Frequency (minutes)</label>
          <input type="number" name="frequency_minutes" value={formData.frequency_minutes} onChange={handleChange} className="input" />
        </div>
        <div>
          <label className="block text-sm font-medium text-dark-300">Frequency (songs)</label>
          <input type="number" name="frequency_songs" value={formData.frequency_songs} onChange={handleChange} className="input" />
        </div>
        <div>
          <label className="block text-sm font-medium text-dark-300">Priority</label>
          <input type="number" name="priority" value={formData.priority} onChange={handleChange} className="input" />
        </div>
        <div>
          <label className="block text-sm font-medium text-dark-300">Start Date</label>
          <input type="date" name="start_date" value={formData.start_date} onChange={handleChange} className="input" />
        </div>
        <div>
          <label className="block text-sm font-medium text-dark-300">End Date</label>
          <input type="date" name="end_date" value={formData.end_date} onChange={handleChange} className="input" />
        </div>
        <button type="submit" className="btn btn-primary">Save</button>
      </form>
    </div>
  );
}
